import CustomComponentLoader from "./CustomComponentLoader";
export default CustomComponentLoader;
